import { render, staticRenderFns } from "./sales-about.vue?vue&type=template&id=1a63c5c8"
import script from "./sales-about.vue?vue&type=script&lang=js"
export * from "./sales-about.vue?vue&type=script&lang=js"
import style0 from "./sales-about.vue?vue&type=style&index=0&id=1a63c5c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports